/* tslint:disable */
/* eslint-disable */
export enum DbrUserTypeEnum {
  $0 = 0,
  $1 = 1
}
